export const RetainedForeignObjectOptions = [
    { name: 'UnknownDiscoveredAfterClosing', description: 'Unknown, Discovered After Closing' },
    { name: 'KnownNotAbleToSafelyRemoveNoHarmToPatient', description: 'Known, Not Able to Safely Remove — No Harm to Patient' },
];
